import React, { memo, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

import { Context as ThemeContext } from '../../../api/theme';

const HeaderThemeToggle = () => {
    const { mode, toggleThemeMode } = useContext(ThemeContext) as any;
    const isDark = mode === 'dark';

    return (
        <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'} arrow>
            <IconButton color="inherit" onClick={toggleThemeMode} size="medium">
                {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default memo(HeaderThemeToggle);
